// extracted by mini-css-extract-plugin
export var button = "styles-module__button___ShZWd";
export var close = "styles-module__close___a0rcY";
export var container = "styles-module__container___UVsry";
export var contentContainer = "styles-module__contentContainer___GPz7P";
export var nameAndRatingContainer = "styles-module__nameAndRatingContainer___CTTXp";
export var ratingContainer = "styles-module__ratingContainer___RlidX";
export var slideIn = "styles-module__slideIn___cxo8w";